import { createApiClient } from 'Network/ApiClient';

export const ActivityFrequencyRelationAxiosInstance = createApiClient('frequencyrelation/');


